import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnFieldName,
  columnFieldLabel,
  columnError,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import TableWrapper from '@/components/table/TableWrapper';
import SimpleCell from '@/components/table/SimpleCell';

const DataManagementDictionaryFieldErrorsTable = ({ errors }) => (
  <TableWrapper celled className="attached aridhia-dictionary-data-management-errors-table" columns={[]}>
    <Table.Header>
      <Table.Row>
        <UnsortedColumn columnId={columnFieldName} />
        <UnsortedColumn columnId={columnFieldLabel} />
        <UnsortedColumn columnId={columnError} />
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {errors.map((error) => (
        <Table.Row key={error.name}>
          <SimpleCell content={error.name} />
          <SimpleCell content={error.label} />
          <SimpleCell content={error.message} />
        </Table.Row>
      ))}
    </Table.Body>
  </TableWrapper>
);

export default DataManagementDictionaryFieldErrorsTable;
